import { type ApiResponse } from "apisauce"

import { request } from "../../../services/api.ts"
import type { BaseApiResponse } from "../../../types/api.ts"

const PATH = "/notifications/sms/send-window/"

export interface SmsSendWindowSettings {
  sms_window_start: string
  sms_window_end: string
  earliest: string
  latest: string
}

export type SmsSendWindowUpdate = Partial<
  Pick<SmsSendWindowSettings, "sms_window_start" | "sms_window_end">
>

export const getSmsSendWindowSettings = (): Promise<
  ApiResponse<SmsSendWindowSettings>
> => request.api.get(PATH)

export const updateSmsSendWindowSettings = (
  payload: SmsSendWindowUpdate
): Promise<ApiResponse<BaseApiResponse<SmsSendWindowSettings>>> =>
  request.api.patch(PATH, payload)
